type JSONParseDefaultValue = '{}' | '[]' | '';

export const getItem = (key: string, parseInto: JSONParseDefaultValue) => {
  return JSON.parse(localStorage.getItem(key) ?? parseInto);
};

export const setItem = (key: string, item: any) => {
  localStorage.setItem(key, JSON.stringify(item));
};

export const setObjectAsSessionStorageItem = (key: string | number, obj: object) => {
  const stringifiedObj =  JSON.stringify(obj);
  window.sessionStorage.setItem(key.toString(), stringifiedObj);
};

export const getItemFromSessionStorage = (key: string, parseInto: string) => {
  return JSON.parse(sessionStorage.getItem(key) ?? parseInto);
};

